import { useState } from "react";
import { useSnackbar } from "notistack";
import { State } from "../../../domain/model/ResponseState";
import { PlayerDeleteAccountUseCase } from "../../../domain/usecase/player/DeleteAccount/UseCase";
import { Player } from "../../../domain/model/User";
import SharedPreferences from "../../../core/utils/SharedPreferences";
import { STORAGE_KEYS } from "../../../data/constant/Constants";
import { showGlobalLoadingView } from "../../../core/utils/Utils";

export function HomeViewModel(
  player: Player | undefined,
  playerDeleteAccountUseCase: PlayerDeleteAccountUseCase
) {
  const { enqueueSnackbar } = useSnackbar();

  const [showDeleteAccountDialog, setShowDeleteAccountDialog] = useState(false);
  const [deleteDialogType, setDeleteDialogType] = useState(1);

  async function deleteAccount() {
    if (!player || !player._id) return;
    showGlobalLoadingView(true);
    const response = await playerDeleteAccountUseCase.invoke(player._id);
    switch (response.responseState) {
      case State.Success:
        showSnackbar(response.data?.message, "success");
        SharedPreferences.clearByKey(STORAGE_KEYS.LOGGED_IN_AS_GUEST);
        SharedPreferences.clearByKey(STORAGE_KEYS.TOKEN);
        break;
      case State.Fail:
      case State.Error:
        setDeleteDialogType(1);
        showSnackbar(response.error?.message);
        break;
    }
    showGlobalLoadingView(false);
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return {
    deleteAccount,
    showDeleteAccountDialog,
    setShowDeleteAccountDialog,
    setDeleteDialogType,
    deleteDialogType,
  };
}
